import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import Login from "../pages/login";
import { useContext } from "react";
import { UserContext } from "../context";
import Dashboard from "../pages/dashboard";
import ROUTES from "../eums/route";
import WorkerList from "../pages/worker-list";
import CompaniesList from "../pages/companies";
import InspectionChecklist from "../pages/inspection-checklist";
import PricesConfig from "../pages/prices-config";
import ServiceOrders from "../pages/service-orders";
import ClientsList from "../pages/clients";
import MaterialList from "../pages/materials";
import Map from "../pages/map";

const AppRouter = () => {
  const { user } = useContext(UserContext);
  const router = createBrowserRouter([
    {
      path: ROUTES.ROOT,
      element: <Login />,
    },
    { path: "*", element: <Navigate to={ROUTES.ROOT} replace /> },
  ]);
  const privateRouter = createBrowserRouter([
    {
      path: ROUTES.ROOT,
      element: <Dashboard />,
      children: [
        {
          path: ROUTES.MAP,
          element: <Map />,
        },
        {
          path: ROUTES.CLIENTS_LIST,
          element: <ClientsList />,
        },
        {
          path: ROUTES.MATERIAL_LIST,
          element: <MaterialList />,
        },

        {
          path: ROUTES.WORKERS_LIST,
          element: <WorkerList />,
        },
        {
          path: ROUTES.COMPANIES_LIST,
          element: <CompaniesList />,
        },
        {
          path: ROUTES.INSPECTION_CHECKLIST,
          element: <InspectionChecklist />,
        },
        {
          path: ROUTES.PRICES_CONFIG,
          element: <PricesConfig />,
        },
        {
          path: ROUTES.SERVICE_ORDERS,
          element: <ServiceOrders />,
        },
      ],
    },
  ]);

  if (user) return <RouterProvider router={privateRouter} />;
  return <RouterProvider router={router} />;
};

export default AppRouter;
